<template>
	<div class="menu-tree flex-column">
		<div class="search">
			<div class="input flex-center">
				<input v-model="menuKeyword" class="flex-grow" placeholder="按文件名称搜索" @keydown.enter="menuSearchHandle">
				<i class="sf sf-search" @click="menuSearchHandle"></i>
			</div>
		</div>
		<div class="menu flex-grow">
			<sub-tree ref="tree" :leading="leading" :load="loadMenuTree" @node-click="$event => $emit('node-click', $event)"></sub-tree>
		</div>
	</div>
</template>

<script>
	import subTree from '@/submodule/components/unit/tree.vue'
	
	export default {
		components: {
			subTree
		},
		
		props: {
			leading: {
				type: Boolean,
				default: true
			},
			
			defaultCurrent: Boolean
		},
		
		data() {
			return {
				menuKeyword: '',
			}
		},
		
		methods: {
			init() {
				this.$refs.tree.update();
			},
			
			clear() {
				this.menuKeyword = '';
				this.$refs.tree.update();
			},
			
			loadMenuTree(node, resolve) {
				if (!node) {
					this.$nextTick(() => {
						resolve([{
							name: '全部文件',
							id: 0
						}]);
						
						this.$nextTick(() => {
							if (this.defaultCurrent) {
								this.selectNode(this.getRoot());
							} else {
								this.getRoot().expand();
							}
						});
					});
					return;
				}
				
				this.request({
					url: '/oss/file/directory',
					data: {
						directory_id: node.data.id
					},
					success: data => {
						data.forEach(item => {
							item.leaf = !item.isParent;
						});
						resolve(data);
					}
				});
			},
			
			selectNode(node) {
				this.$refs.tree.selectNode(node);
			},
			
			getRoot() {
				return this.$refs.tree.getNode()[0];
			},
			
			getCurrent() {
				return this.$refs.tree.getNode('selected');
			},
			
			menuSearchHandle() {
				if (!this.menuKeyword.trim()) {
					this.getRoot().load();
					return;
				}
				this.request({
					url: '/oss/file/directory_search',
					data: {
						directory_name: this.menuKeyword.trim()
					},
					success: data => {
						let temp = {}, node = [];
						data.forEach(item => {
							if (!temp[item.pId]) {
								temp[item.pId] = [];
							}
							temp[item.pId].push(item);
							
							if (!temp[item.id]) {
								temp[item.id] = [];
							}
							item.children = temp[item.id];
							
							if (item.pId == 0) {
								node.push(item);
							}
							item.leaf = !item.isParent;
						});
						
						this.getRoot().load(node);
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.menu-tree {
		height: 100%;
		
		.search {
			padding: 10px;
			border-bottom: 1px solid #ddd;
			
			.input {
				height: 26px;
				border: 1px solid #aaa;
				border-radius: 2px;
				
				input {
					height: 100%;
					padding-left: 6px;
					font-size: 13px;
				}
				
				.sf {
					width: 26px;
					line-height: 26px;
					font-size: 14px;
					text-align: center;
					color: #999;
					cursor: pointer;
				}
			}
		}
		
		.menu {
			overflow: auto;
		}
	}
</style>
